import type { DepartmentUnit, DepartmentsResponse } from "@ncp/assistant-sdk/contracts";

export function flattenUnits(units: DepartmentUnit[]): DepartmentUnit[] {
  return units.flatMap((unit) => [unit, ...(unit.departments ?? [])]);
}

export const canSwitchTo = (unit: DepartmentUnit | null | undefined): boolean =>
  !!unit && unit.member && unit.status === "live" && !!unit.workspace;

/** Department confirmation grants Knowledge Bank access; only the workspace catalog grants a chat workspace. */
export function departmentState(server: DepartmentsResponse, workspaceKeys: readonly string[], workspaceKey: string | null) {
  const reachable = new Set(workspaceKeys);
  const map = (unit: DepartmentUnit): DepartmentUnit => ({
    ...unit,
    member: unit.workspace ? reachable.has(unit.workspace) : unit.member,
    ...(unit.departments ? { departments: unit.departments.map(map) } : {}),
  });
  const units = server.units.map(map);
  const all = flattenUnits(units);
  const mine = all.filter(canSwitchTo);
  const stored = mine.find((unit) => unit.key === server.current) ?? null;
  const current = mine.find((unit) => unit.workspace === workspaceKey) ?? stored ?? mine[0] ?? null;
  const data: DepartmentsResponse = {
    ...server,
    units,
    current: stored?.key ?? null,
    otherWorkspaces: server.otherWorkspaces.filter((workspace) => reachable.has(workspace.key)),
  };
  return { data, current, mine, all };
}
